import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LoginWithGoogle, auth } from "../../firebase/firebase.utils";
import RetroButton from "../retro/button/retro-button.component";
import Input from "../retro/input/input.component";
import Loading from "../retro/loading/loading.component";
import "./login.styles.scss";

const friendlyLoginError = (error) => {
  switch (error?.code) {
    case "auth/user-disabled":
      return "Sign-in is disabled for this account. Use ‘Account Details or Appeal’ below to verify your email, see available details, and request a review.";
    case "auth/invalid-email":
      return "Please enter a valid email address.";
    case "auth/user-not-found":
    case "auth/wrong-password":
    case "auth/invalid-credential":
    case "auth/invalid-login-credentials":
      return "The email or password is incorrect.";
    case "auth/popup-closed-by-user":
      return "Google sign-in was cancelled.";
    case "auth/popup-blocked":
      return "Your browser blocked the Google sign-in window.";
    case "auth/too-many-requests":
      return "Too many attempts. Please wait before trying again.";
    case "auth/network-request-failed":
      return "Check your connection and try again.";
    default:
      return "Sign in failed. Please try again.";
  }
};

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showAccountAccess, setShowAccountAccess] = useState(false);

  const loginWithEmailAndPassword = async (event) => {
    event?.preventDefault?.();
    if (busy) return;
    setErrorMessage("");
    setShowAccountAccess(false);
    if (!email.trim() || !password) {
      setErrorMessage("Email and password are required.");
      return;
    }
    try {
      setBusy(true);
      await auth.signInWithEmailAndPassword(
        email.trim().toLowerCase(),
        password,
      );
      // App.js still owns verification and profile routing.
    } catch (error) {
      console.error("Email sign-in failed:", error);
      setShowAccountAccess(error?.code === "auth/user-disabled");
      setErrorMessage(friendlyLoginError(error));
    } finally {
      setBusy(false);
    }
  };
  const loginWithGoogle = async () => {
    if (busy) return;
    setErrorMessage("");
    setShowAccountAccess(false);
    try {
      setBusy(true);
      await LoginWithGoogle();
    } catch (error) {
      console.error("Google sign-in failed:", error);
      setShowAccountAccess(error?.code === "auth/user-disabled");
      setErrorMessage(friendlyLoginError(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      {busy && <Loading />}
      <div>
        <img
          src="/homepage/signin.png"
          width="360"
          height="100%"
          alt="Sign in"
        />
      </div>
      <div>
        <h2>Login</h2>
        <form onSubmit={loginWithEmailAndPassword}>
          <Input
            placeholder="Email"
            type="email"
            value={email}
            autoComplete="email"
            disabled={busy}
            onChange={(event) => {
              if (busy) return;
              setEmail(event.target.value);
              setShowAccountAccess(false);
              setErrorMessage("");
            }}
          />
          <Input
            placeholder="Password"
            type="password"
            value={password}
            autoComplete="current-password"
            disabled={busy}
            onChange={(event) => {
              if (busy) return;
              setPassword(event.target.value);
              setShowAccountAccess(false);
              setErrorMessage("");
            }}
          />
          <RetroButton
            type="submit"
            onClick={loginWithEmailAndPassword}
            style={{ width: "100%" }}
          >
            Login
          </RetroButton>
        </form>
        <hr />
        <RetroButton onClick={loginWithGoogle} style={{ width: "100%" }}>
          Login with Google
        </RetroButton>
        {errorMessage && (
          <div className="login__error" role="alert">
            <p>{errorMessage}</p>
          </div>
        )}
        {showAccountAccess && (
          <p className="login__accountHelp">
            <Link
              to="/account-access"
              state={{ email: email.trim().toLowerCase() }}
            >
              Account Details or Appeal
            </Link>
          </p>
        )}
      </div>
    </div>
  );
};
export default Login;
